import React, { useContext } from 'react';
import WindowWrapper from '../context/WindowWrapper';
import PlacesAutoComplete from '../forms/PlacesAutoComplete';
import PrimaryButton from '../buttons/PrimaryButton';
import { TrackingContext } from '../context/Tracking';
import SelectField from '../forms/SelectField';
import DomainData from '../../assets/datasets/DomainData';
import InputField from '../forms/InputField';
import { AuthContext } from '../context/Auth';
import { createUserProfile } from '../../api/methods';

const valid = (data) => {
  if (!data.phone) return alert("Bitte gib' deine Handy-Nr. an - nur so können wir dich erreichen, wenn wir eine Klinik gefunden haben, die passen könnte.");
  if (data.areasOfExpertise.length === 0) return alert("Bitte gib' dein(e) Wunschfachgebiet(e) an, damit wir wissen, wo wir für dich suchen können.");
  return true;
};

const WizardWindow = ({ style, close, className, content, ...props }) => {
  const [cities, setCities] = React.useState([]);
  const [areasOfExpertise, setAreasOfExpertise] = React.useState([]);
  const [formValues, setFormValues] = React.useState({
    city: '',
    areaOfExpertise: null,
    phone: ''
  });
  const { auth, user, reloadUser } = useContext(AuthContext);

  React.useEffect(() => {
    if (user?.profileInformation?.phone) {
      setCities(user?.profileInformation?.profile_information?.cities || []);
      setAreasOfExpertise(user?.profileInformation?.profile_information?.areasOfExpertise || []);
      setFormValues(old => ({ ...old, phone: user?.profileInformation?.phone || '' }));
    }
  }, []);

  const confirm = async () => {
    const profileInformation = {
      cities,
      areasOfExpertise
    };
    const profileData = {
      user_id: user.id,
      phone: formValues.phone,
      profile_information: profileInformation
    };
    if (valid({ ...profileData, ...profileInformation }) !== true) return;
    try {
      await createUserProfile(profileData, auth.jwt);
      await reloadUser();
      close();
    } catch (error) {
      alert('Fehler: ' + error.message);
    }
    // close();
  };

  return (
    <>
      <WindowWrapper
        maxWidth={600}
        maxHeight={600}
        className={'window-wrapper nice-scroll ' + (className || '')}
        style={{ padding: 40, ...style }}
        close={close}
      >
        <h3 style={{ marginTop: -40 }}><b>Wir melden uns bei dir, wenn wir einen guten Arbeitgeber finden</b></h3>
        <p>
          Wir arbeiten mit vielen Kliniken zusammen und bekommen gute Einblicke.<br />
          Sag uns, was du suchst und wir melden uns, wenn wir etwas Passendes für dich finden!
        </p>
        <br />
        <b>In welcher Stadt suchst du?</b>
        <PlacesAutoComplete
          name='wizard_places'
          setCenterAndZoomIn={data => setFormValues(oldFV => { setCities(old => [...old, { position: data, name: oldFV.city }]); return { ...oldFV, city: '' }; })}
          map={props.mapInstance}
          mapApi={props.mapApi}
          setValue={value => setFormValues(old => ({ ...old, city: value }))}
          value={formValues.city}
          style={{ marginBottom: 10 }}
        />
        <p style={{ fontSize: 11 }}>*Gib' einfach nichts an, wenn dir die Stadt egal ist.</p>
        {
          cities.map((city, i) => {
            return (
              <p key={city.name} style={{ marginBottom: 0, color: 'grey' }}>
                <span>{city.name}</span>&nbsp;&nbsp;<span onClick={() => setCities(old => { const newCities = [...old]; newCities.splice(i, 1); return newCities; })} style={{ color: 'red', cursor: 'pointer', fontSize: 'larger', fontWeight: 'bold' }}>x</span>
              </p>
            );
          })
        }
        <br />
        <b>Für welche Fachgebiete?</b>
        <SelectField
          label='Fachgebiet'
          setValue={(subjectArea) => setAreasOfExpertise(old => old.includes(subjectArea) ? old : [...old, subjectArea])}
          value={formValues.areasOfExpertise}
          placeholder='Auswählen...'
          options={[...DomainData.areasOfExpertise, { value: 'offen für alles', label: 'offen für alles' }]}
        />
        {
          areasOfExpertise.map((areaOfExpertise, i) => {
            return (
              <p key={areaOfExpertise} style={{ marginBottom: 0, color: 'grey' }}>
                <span>{areaOfExpertise}</span>&nbsp;&nbsp;<span onClick={() => setAreasOfExpertise(old => { const newAreasOfExpertise = [...old]; newAreasOfExpertise.splice(i, 1); return newAreasOfExpertise; })} style={{ color: 'red', cursor: 'pointer', fontSize: 'larger', fontWeight: 'bold' }}>x</span>
              </p>
            );
          })
        }
        <br />
        <b>Deine Kontaktdaten</b>
        <br />
        <p style={{ marginTop: 10, fontSize: 'small' }}><b>E-Mail: </b>{user.email}</p>
        <InputField
          label='Handy-Nr.'
          value={formValues.phone}
          setValue={value => setFormValues(old => ({ ...old, phone: value }))}
          placeholder='Handy-Nr.'
        />
        <p style={{ fontSize: 11 }}>*Wir rufen nur an, wenn wir einen potenziellen Arbeitgeber für dich gefunden haben.</p>
        <PrimaryButton style={{ float: 'right' }} onClick={() => confirm()}>Bestätigen</PrimaryButton>
      </WindowWrapper>
    </>
  );
};

export default WizardWindow;
